<template>
  <div id="sidenav">
    <div class="tit bg-primary">
      <span class="ml-30 color-white fs-22">{{
        type == 1 ? "关于我们" : "图书分类"
      }}</span>
    </div>
    <ul class="nav">
      <li
        class="flex ai-center point"
        :style="{ height: type == 1 ? '0.4rem' : type == 2?'0.32rem':'0.35rem' }"
        :class="
          choseid == index && clickid == index
            ? 'bg-colf6 activetransform'
            : choseid == index
            ? 'bg-colf6 activetransform'
            : clickid == index
            ? 'bg-colf6 activetransform'
            : ''
        "
        v-for="(item, index) in navlist"
        :key="index"
        @click="chosenav(index)"
        @mouseenter="movenav(index)"
        @mouseleave="leavenav(index)"
      >
        <div
          class="line"
          :style="{ height: choseid == index ? '100%' : '0%' }"
          :class="
            choseid == index && clickid == index
              ? 'bg-primary'
              : choseid == index
              ? 'bg-primary'
              : clickid == index
              ? 'bg-primary'
              : ''
          "
        ></div>
        <img
          class="icon ml-30"
          :src="
            choseid == index || clickid == index
              ? navicon[index].imgactive
              : navicon[index].img
          "
          alt=""
        />
        <span class="ml-20 fs-18" :class="choseid == index ? 'color-primary' : ''">{{
          item.name
        }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "sidenav",
  props: ["navlist", "type", "navicon", "chosenavid"],
  data() {
    return {
      choseid: -1,
      clickid: -1,
    };
  },
  mounted() {
    if (this.type == 1) {
      if (this.chosenavid) {
        this.choseid = this.chosenavid;
        this.clickid = this.chosenavid;
      } else {
        this.choseid = 0;
        this.clickid = 0;
      }
    } else {
      this.choseid = -1;
      this.clickid = -1;
    }
  },
  methods: {
    //导航切换
    chosenav(index) {
      this.clickid = index;
      this.$emit("getnav", index);
    },
    movenav(index) {
      this.choseid = index;
    },
    leavenav() {
      this.choseid = -1;
    },
  },
};
</script>
<style lang="scss" scoped>
#sidenav {
  width: 230px;
  max-height: 542px;
  background: #ffffff;
  .tit {
    width: 100%;
    height: 70px;
    line-height: 70px;
  }
  .nav {
    width: 99%;
    background: #ffffff;
    border: 1px solid #ededed;
    li {
      width: 100%;
      .line {
        width: 5px;
        transition: height 0.5s linear;
      }
      .icon {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
